import React, { useEffect, useState } from "react";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import useHttp from "../../../hook/use-http";
import NoTableData from "./NoTableData";
import ChartLoader from "./ChartLoader";
import WaterMark from "../DashboardMain_Bus/WaterMark";
import styles from './EnergyBillReconcilliation_Bus.module.css'
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { dateFormat } from "../../../util/dateTimeUtils";

export default function TabularData_Bus({ gloablfilter, extraThings }) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [tableDataDrive, setTableDataDrive] = useState([]);
  const [tableDataEnergy, setTableDataEnergy] = useState([]);
  const [tableData, setTableData] = useState(null);
  const [loader, setLoader] = useState(true);

  const api_resDrive = async (data) => {
    setTableDataDrive(data);

    const tempApiEndPoint = extraThings["apiEndPoint"]
    const myArray = tempApiEndPoint.split("_");
    await fetchData({ url: API_URL_MAIN + "energy_bill_reconcilliation/" + myArray[1], body: { filterdata: gloablfilter } }, (dataEnergy) => api_resEnergy(data, dataEnergy))
  }

  const api_resEnergy = async (driveData, energyData) => {
    setTableDataEnergy(energyData);
    await bothResp(driveData, energyData)
  }

  // const bothResp = async (data11, data22) => {
  //   // Create a map for data22 to access records by vehicleId
  //   const data22Map = new Map(data22.map(item => [item.key.vehicleId, item]));

  //   // Combine records from data11 that have matching vehicleId in data22
  //   const combinedArray = data11
  //     .filter(item11 => data22Map.has(item11.key.vehicleId))
  //     .map(item11 => {
  //       const matchedItem22 = data22Map.get(item11.key.vehicleId);

  //       // Combine fields from both records into one
  //       return {
  //         vehicleId: item11.key.vehicleId,
  //         doc_count: item11.doc_count,
  //         min_starttime: item11.min_starttime,
  //         max_endtime: item11.max_endtime,
  //         sum_distance_in_km: item11.sum_distance_in_km,
  //         additional_fields: item11.additional_fields,
  //         sum_netkwh: item11.sum_netkwh,
  //         kwhperKM: item11.kwhperKM,

  //         // Fields from data22
  //         sum_dataRegen_kWh: matchedItem22.sum_dataRegen_kWh,
  //         sum_dataNet_kWh: matchedItem22.sum_dataNet_kWh,
  //         sum_distanceInKM: matchedItem22.sum_distanceInKM,
  //         net_kWh_per_km: matchedItem22.net_kWh_per_km,
  //         regen_kWh_per_km: (item11.kwhperKM * matchedItem22.percentage_regen).toFixed(2),
  //         percentage_regen: matchedItem22.percentage_regen,
  //       };
  //     });
  //   setTableData(combinedArray);
  //   if (combinedArray.length > 0) { setLoader(false); setTableData(combinedArray); } else { setLoader(false); }
  // }

  const bothResp = async (data11, data22) => {
    // Create a map for data22 to access records by vehicleId
    const data22Map = new Map(data22.map(item => [item.key.vehicleId, item]));

    // Combine records from data11 and fill missing fields with 'NA' if no match found
    const combinedArray = data11.map(item11 => {
      const matchedItem22 = data22Map.get(item11.key.vehicleId);

      return {
        vehicleId: item11.key.vehicleId,
        doc_count: item11.doc_count,
        min_starttime: item11.min_starttime,
        max_endtime: item11.max_endtime,
        sum_distance_in_km: item11.sum_distance_in_km,
        additional_fields: item11.additional_fields,
        sum_netkwh: item11.sum_netkwh,
        kwhperKM: item11.kwhperKM,

        // Fields from data22 (if available, otherwise set 'NA')
        sum_dataRegen_kWh: matchedItem22 ? matchedItem22.sum_dataRegen_kWh : 'NA',
        sum_dataNet_kWh: matchedItem22 ? matchedItem22.sum_dataNet_kWh : 'NA',
        sum_distanceInKM: matchedItem22 ? matchedItem22.sum_distanceInKM : 'NA',
        net_kWh_per_km: matchedItem22 ? matchedItem22.net_kWh_per_km : 'NA',
        regen_kWh_per_km: matchedItem22 ? (item11.kwhperKM * matchedItem22.percentage_regen).toFixed(2) : 'NA',
        percentage_regen: matchedItem22 ? matchedItem22.percentage_regen : 'NA',
      };
    });

    setTableData(combinedArray);
    setLoader(false);
  };

  useEffect(() => {
    const tempApiEndPoint = extraThings["apiEndPoint"]
    const myArray = tempApiEndPoint.split("_");
    fetchData({ url: API_URL_MAIN + "energy_bill_reconcilliation/" + myArray[0], body: { filterdata: gloablfilter } }, api_resDrive)
  }, [gloablfilter])

  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheettml.sheet;charset=UTF-8";
  const downloadcsvdata = () => {

    const selectedFieldsData = tableData.map((item, index) => ({
      "Sr No.": index + 1,
      "Vin No.": item?.vehicleId,
      "Registraion No.": item?.additional_fields?.hits?.hits[0]?._source?.vehicle_registration_number,
      "Start Time": dateFormat(item?.min_starttime?.value_as_string),
      "End Time": dateFormat(item?.max_endtime?.value_as_string),
      "Distance In km": item?.sum_distance_in_km?.value,
      "Net kwh": item?.sum_netkwh?.value,
      "KwhPerKM": item?.kwhperKM?.value.toFixed(2),
      "Regen KwhPerKM": (item?.kwhperKM?.value * item?.percentage_regen?.value).toFixed(2),
      "LOB": item?.additional_fields?.hits?.hits[0]?._source?.LOB,
      "PL": item?.additional_fields?.hits?.hits[0]?._source?.PL,
      "PPL": item?.additional_fields?.hits?.hits[0]?._source?.PPL,
      "City": item?.additional_fields?.hits?.hits[0]?._source?.DLR_ORG_CITY,
      "Depo": item?.additional_fields?.hits?.hits[0]?._source?.Depot_Name,
      "Air Ventilation": item?.additional_fields?.hits?.hits[0]?._source?.air_ventilation
    }));
    const ws = XLSX.utils.json_to_sheet(selectedFieldsData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] }
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data1 = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data1, "Energy_Bill_Reconcilliation.xlsx")
  }

  return (
    <>
      <div className={`col-lg-12 col-md-12 col-sm-12 mt-3`}>
        <div className={`${styles.reconcilChartboxNew_Bus}`}>
          <div className={`v-title ${styles.engBlReconTitleChart_Bus}`}>
            <div className="row p-2">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <b>{extraThings["title"]}</b>
              </div>
            </div>
          </div>
          <div className={`${styles.tableContent_Bus} px-2`} style={{ overflowY: 'scroll', height: '500px' }}>
            <WaterMark />
            <table className="table table-striped">
              <thead style={{ backgroundColor: '#83A4CF', color: '#fff', position: 'sticky', top: 0 }}>
                <tr>
                  <th scope="col">Sr No.</th>
                  <th scope="col">Vin No.</th>
                  <th scope="col">Registraion No.</th>
                  <th scope="col">Start Time</th>
                  <th scope="col">End Time</th>
                  <th scope="col">Distance In km</th>
                  <th scope="col">Net kwh</th>
                  <th scope="col">KwhPerKM</th>
                  <th scope="col">Regen KwhPerKM</th>
                  <th scope="col">LOB</th>
                  <th scope="col">PL</th>
                  <th scope="col">PPL</th>
                  <th scope="col">City</th>
                  <th scope="col">Depo</th>
                  <th scope="col">Air Ventilation</th>
                </tr>
              </thead>
              <tbody>
                {loader ? (
                  <ChartLoader />
                ) : tableData === null || tableData.length === 0 ? (
                  <NoTableData />
                ) : (
                  tableData.map((x, index) => (
                    <tr key={index}>
                      <td scope="row">{index + 1}</td>
                      <td scope="row">{x?.vehicleId}</td>
                      <td scope="col">{x?.additional_fields?.hits?.hits[0]?._source?.vehicle_registration_number}</td>
                      <td scope="col">{dateFormat(x?.min_starttime?.value_as_string)}</td>
                      <td scope="col">{dateFormat(x?.max_endtime?.value_as_string)}</td>
                      <td scope="col">{x?.sum_distance_in_km?.value}</td>
                      <td scope="col">{x?.sum_netkwh?.value}</td>
                      <td scope="col">{x?.kwhperKM?.value.toFixed(2)}</td>
                      <td scope="col">{(x?.kwhperKM?.value * x?.percentage_regen?.value).toFixed(2)}</td>
                      <td scope="col">{x?.additional_fields?.hits?.hits[0]?._source?.LOB}</td>
                      <td scope="col">{x?.additional_fields?.hits?.hits[0]?._source?.PL}</td>
                      <td scope="col">{x?.additional_fields?.hits?.hits[0]?._source?.PPL}</td>
                      <td scope="col">{x?.additional_fields?.hits?.hits[0]?._source?.DLR_ORG_CITY}</td>
                      <td scope="col">{x?.additional_fields?.hits?.hits[0]?._source?.Depot_Name}</td>
                      <td scope="col">{x?.additional_fields?.hits?.hits[0]?._source?.air_ventilation}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="col-lg-2 col-md-6 col-sm-12">
        <div className="mt-2">
          <button type="submit" className={`form-control btn btn-primary ${styles.downloadButton}`} onClick={downloadcsvdata}>Download</button>
        </div>
      </div>
    </>
  )
}
